import { useNavigate } from 'react-router-dom'
import { useOrgStore } from '@/stores/orgStore'
import { useAuthStore } from '@/stores/authStore'
import { authApi } from '@/api/clients/authApi'
import { useTheme } from '@/contexts/ThemeContext'

export default function Settings() {
  const { orgName } = useOrgStore()
  const { theme, toggleTheme } = useTheme()
  const { refreshToken, userEmail, role, clearSession } = useAuthStore()
  const navigate = useNavigate()

  const handleLogout = async () => {
    if (refreshToken) {
      await authApi.logout(refreshToken).catch(() => {/* best-effort */})
    }
    clearSession()
    navigate('/login', { replace: true })
  }

  return (
    <div className="space-y-6 max-w-2xl">
      <div>
        <h1 className="text-2xl font-bold text-text-light dark:text-text-dark">Settings</h1>
        <p className="text-sm text-subtle-light dark:text-subtle-dark mt-0.5">
          Configure the Quantizant Discovery
        </p>
      </div>

      {/* Account */}
      <div className="bg-surface-light dark:bg-gradient-to-r dark:from-[#0d1b2a] dark:to-[#111e2e] rounded-xl shadow-ambient dark:shadow-none border border-border-light dark:border-border-dark p-6">
        <h2 className="text-base font-semibold text-text-light dark:text-text-dark mb-4">
          Account
        </h2>
        <div className="flex items-start justify-between gap-4">
          <div className="space-y-1">
            {userEmail && (
              <p className="text-sm font-medium text-text-light dark:text-text-dark">{userEmail}</p>
            )}
            {role && (
              <p className="text-xs text-subtle-light dark:text-subtle-dark capitalize">{role}</p>
            )}
            <p className="text-xs text-subtle-light dark:text-subtle-dark">
              Organisation:{' '}
              <span className="font-medium text-text-light dark:text-text-dark">{orgName}</span>
            </p>
          </div>
          <button
            onClick={handleLogout}
            className="shrink-0 flex items-center gap-2 px-4 py-2 text-sm rounded-lg hover:bg-background-light dark:hover:bg-background-dark text-error"
          >
            <span className="material-icons text-base">logout</span>
            Sign out
          </button>
        </div>
      </div>

      {/* Appearance */}
      <div className="bg-surface-light dark:bg-gradient-to-r dark:from-[#0d1b2a] dark:to-[#111e2e] rounded-xl shadow-ambient dark:shadow-none border border-border-light dark:border-border-dark p-6">
        <h2 className="text-base font-semibold text-text-light dark:text-text-dark mb-4">
          Appearance
        </h2>
        <div className="flex items-center justify-between">
          <div>
            <p className="text-sm font-medium text-text-light dark:text-text-dark">Theme</p>
            <p className="text-xs text-subtle-light dark:text-subtle-dark mt-0.5">
              Currently: <strong>{theme}</strong> mode
            </p>
          </div>
          <button
            onClick={toggleTheme}
            className="flex items-center gap-2 px-4 py-2 text-sm rounded-lg hover:bg-background-light dark:hover:bg-background-dark text-text-light dark:text-text-dark"
          >
            <span className="material-icons text-base">
              {theme === 'light' ? 'dark_mode' : 'light_mode'}
            </span>
            Switch to {theme === 'light' ? 'Dark' : 'Light'} Mode
          </button>
        </div>
      </div>

      {/* About */}
      <div className="bg-surface-light dark:bg-gradient-to-r dark:from-[#0d1b2a] dark:to-[#111e2e] rounded-xl shadow-ambient dark:shadow-none border border-border-light dark:border-border-dark p-6">
        <h2 className="text-base font-semibold text-text-light dark:text-text-dark mb-4">About</h2>
        <div className="space-y-2 text-sm text-subtle-light dark:text-subtle-dark">
          <p>
            <strong className="text-text-light dark:text-text-dark">Quantizant Discovery</strong> —
            v0.1.0
          </p>
          <p>Frontend for the Quantizant PQC Transition Platform discovery module.</p>
          <p>
            Discovers cryptographic assets (keys, certificates, algorithms, protocols) across
            source code, runtime, network, and infrastructure.
          </p>
        </div>
      </div>
    </div>
  )
}
